
import * as React from "react"
import { State } from "./toast/types"
import { toast } from "./toast/toast-store"
import { listeners, getState } from "./toast/toast-reducer"
import { dispatch } from "./toast/toast-store"

function useToast() {
  // Create state with a direct call to React.useState to avoid any potential circular dependencies
  const [state, setState] = React.useState<State>(getState())

  React.useEffect(() => {
    // Add the state setter to listeners
    listeners.push(setState)
    
    // Clean up listener when component unmounts
    return () => {
      const index = listeners.indexOf(setState)
      if (index > -1) {
        listeners.splice(index, 1)
      }
    }
  }, []) // Empty dependency array to run only on mount/unmount

  return {
    ...state,
    toast,
    dismiss: (toastId?: string) => dispatch({ type: "DISMISS_TOAST", toastId }),
  }
}

export { useToast, toast }
